import { ncbData, publicDataFetch } from '../api';

const TABLE = 'donation_impact_updates_1783000002';

export async function listDonationImpactUpdates(campaignId) {
  const query = new URLSearchParams({
    campaign_id: String(campaignId),
    sort: 'impact_date',
    order: 'desc',
    limit: '25',
  });
  const result = await publicDataFetch(`read/${TABLE}?${query}`);

  if (result?.status !== 'success') {
    return { status: 'error', data: [], error: result?.error || 'Unable to load updates.' };
  }

  return {
    status: 'success',
    data: Array.isArray(result?.data) ? result.data : [],
  };
}

export async function createDonationImpactUpdate(payload) {
  const result = await ncbData('create', TABLE, payload);

  if (result?.status !== 'success') {
    return {
      status: 'error',
      data: null,
      error: result?.error || 'Unable to publish this update.',
    };
  }

  return { status: 'success', data: result?.data ?? null };
}